import { render, staticRenderFns } from "./bannerMenu.vue?vue&type=template&id=70d07540&scoped=true"
import script from "./bannerMenu.vue?vue&type=script&lang=js"
export * from "./bannerMenu.vue?vue&type=script&lang=js"
import style0 from "./bannerMenu.vue?vue&type=style&index=0&id=70d07540&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d07540",
  null
  
)

export default component.exports